import { render, staticRenderFns } from "./ProcessWorkPermit.vue?vue&type=template&id=2a52f6fc&scoped=true"
import script from "./js/ProcessWorkPermit.js?vue&type=script&lang=js&external"
export * from "./js/ProcessWorkPermit.js?vue&type=script&lang=js&external"
import style0 from "./ProcessWorkPermit.vue?vue&type=style&index=0&id=2a52f6fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a52f6fc",
  null
  
)

export default component.exports